import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import IssueInformation from 'components/IssueInformation';

class IssueDetails extends Component {
  handleBack = () => {
    browserHistory.goBack();
  }

  render() {
    const { issue } = this.props.location.state;
    const { appointment } = this.props.location.state;
    return (
      <div className="card d-flex pb-2">
        <div className="px-4 px-lg-5 pt-4 pt-lg-5">
          <div
            className="teacher-listing-edit__back d-flex align-items-center btn-cursor mb-4"
            onClick={this.handleBack}
          >
            <img
              className="teacher-listing-edit__back-icon"
              src="/assets/right-chevron.svg"
              alt="back"
            />
            <span className="ml-2">Back</span>
          </div>

          <h4 className="mb-0">Issue Details</h4>
          <IssueInformation issue={issue} appointment={appointment} />
          {issue.issueDispute && (
            <div>
              <div className="mt-4">
                <div>
                  <strong>Teacher Dispute:</strong>
                </div>
                <div>{issue.issueDispute.reason}</div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default IssueDetails;



// WEBPACK FOOTER //
// ./src/pages/teacher/Schedule/IssueDetails/index.js